module.exports = __webpack_public_path__ + "img/skim-pengesahan-bahan-tanaman-1.633a32d3.jpeg";